import BaseViewController from "./base-view-controller";

class MessageCenterListViewController extends BaseViewController {
  formState = {};

  prepareSubmit(values) {
    if (this.formState.actor_type === "PersonRelation") {
      return {
        ...values,
        actor_id: this.formState.actor_id,
        actor_type: this.formState.actor_type,
        message_id: this.formState.message_id
      };
    }
    return {
      ...values,
      consultation_id: this.formState.consultation_id,
      actor_type: this.formState.actor_type
    };
  }

  handleButtonClick(name, text, action) {
    if (text) {
      this.formState = { ...text.url_request_data };
    }
    super.handleButtonClick(name, text, action);
  }
}

export default MessageCenterListViewController;
